import routerOptions0 from "/home/runner/work/acq-booking-frontend--form/acq-booking-frontend--form/app/node_modules/nuxt/dist/pages/runtime/router.options";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export default {
...configRouterOptions,
...routerOptions0,
}